//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'NGASR',
  data () {
    return {
      form: {
        data1: '',
        data2: '',
        data3: '',
        data4: '',
        data5: '',
        data6: '',
        data7: '',
        data8: '',
        data9: '',
        data10: '',
        data11: '',
        data12: '',
        data13: '',
        data14: '',
        data15: '',
        data16: '',
        data17: '',
        data18: '',
        data19: '',
        data20: '',
        data21: '',
        data22: '',
        data23: '',
        data24: '',
        data25: '',
        data26: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: '1', name: '轻' },
        { value: '2', name: '中' },
        { value: '3', name: '重' }
      ],
      dataList2: [
        { value: '0', name: '无' },
        { value: '1', name: '有' }
      ],
      dataList3: [
        { value: '0', name: '无' },
        { value: '1', name: '偶尔' },
        { value: '2', name: '经常' }
      ],
      dataList4: [
        { value: '0', name: '无' },
        { value: '1', name: '轻度' },
        { value: '2', name: '强烈' }
      ],
      dataList5: [
        { value: '0', name: '无' },
        { value: '1', name: '短暂' },
        { value: '2', name: '持续' }
      ],
      dataList6: [
        { value: '1', name: '偶尔' },
        { value: '2', name: '多次' }
      ],
      dataList7: [
        { value: '1', name: '盲目' },
        { value: '2', name: '有计划' }
      ],
      dataList8: [
        { value: '1', name: '犹豫' },
        { value: '2', name: '下决心' }
      ],
      dataList9: [
        { value: '1', name: '自责，自我评价低' },
        { value: '2', name: '自罪' }
      ],
      dataList10: [
        { value: '0', name: '无' },
        { value: '1', name: '有（无具体方式）' },
        { value: '2', name: '方法容易达到和实施' }
      ],
      dataList11: [
        { value: '1', name: '容易发现，可以救治' },
        { value: '2', name: '隐秘，难以救治' }
      ],
      dataList12: [
        { value: '0', name: '无' },
        { value: '2', name: '有' }
      ],
      dataList13: [
        { value: '0', name: '无' },
        { value: '2', name: '有' }
      ],
      dataList14: [
        { value: '0', name: '无' },
        { value: '2', name: '有' }
      ],
      dataList15: [
        { value: '0', name: '小于45岁' },
        { value: '1', name: '大于等于45岁' }
      ],
      dataList16: [
        { value: '1', name: '女' },
        { value: '2', name: '男' }
      ],
      dataList17: [
        { value: '0', name: '已婚' },
        { value: '1', name: '未婚' },
        { value: '2', name: '离异或丧偶' }
      ],
      dataList18: [
        { value: '0', name: '在职；在校' },
        { value: '1', name: '失业；无业' }
      ],
      dataList19: [
        { value: '0', name: '身体健康' },
        { value: '1', name: '患病多年（未影响功能）' },
        { value: '2', name: '患病多年（影响功能）' }
      ],
      dataList20: [
        { value: '0', name: '无' },
        { value: '1', name: '有' }
      ],
      dataList21: [
        { value: '0', name: '积极乐观' },
        { value: '1', name: '内向，自卑，冲动' }
      ],
      dataList22: [
        { value: '0', name: '良好' },
        { value: '1', name: '差' }
      ],
      dataList23: [
        { value: '0', name: '事业有成' },
        { value: '1', name: '有一事无成' }
      ],
      dataList24: [
        { value: '0', name: '交友多' },
        { value: '1', name: '交友少' }
      ],
      dataList25: [
        { value: '0', name: '无' },
        { value: '1', name: '有' }
      ],
      dataList26: [
        { value: '0', name: '良好' },
        { value: '1', name: '差' }
      ]
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      console.log(form, 7777)
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            console.log(key, form[key], 8888)
            form[key] = Number(form[key])
          }
        }
      }

      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // weight + airways + systolicBP + cns + cutaneousWound + fracture
        let result = 0
        for (const key in form) {
          if (form.hasOwnProperty(key)) {
            result = form[key] + result
          }
        }
        console.log(result, 6666)
        self.hasScore = true
        if (result <= 10) {
          return '较为安全'
        } else if (result <= 20 && result > 10) {
          return '危险'
        } else if (result <= 30 && result > 20) {
          return '非常危险'
        } else if (result > 30) {
          return '极度危险'
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/NGASR.vue